export function matrixInversion(A) {
    const n = A.length;

    // build augmented matrix
    const aug = Array.from({ length: n }, (_, i) => {
        const row = A[i].slice();
        const id = Array.from({ length: n }, (_, j) => (i === j ? 1 : 0));
        return row.concat(id);
    });

    // Gaussian elimination
    for (let i = 0; i < n; i++) {
        // pivot selection
        let maxRow = i;
        for (let k = i + 1; k < n; k++) {
            if (Math.abs(aug[k][i]) > Math.abs(aug[maxRow][i])) maxRow = k;
        }

        // if singular, no inverse
        if (Math.abs(aug[maxRow][i]) < 1e-15) return null;

        // swap pivot row
        if (maxRow !== i) {
            const tmp = aug[i];
            aug[i] = aug[maxRow];
            aug[maxRow] = tmp;
        }

        // normalize
        const piv = aug[i][i];
        for (let j = i; j < 2 * n; j++) aug[i][j] /= piv;

        // eliminate
        for (let r = 0; r < n; r++) {
            if (r === i) continue;
            const factor = aug[r][i];
            if (factor === 0) continue;
            for (let c = i; c < 2 * n; c++) aug[r][c] -= factor * aug[i][c];
        }
    }

    return Array.from({ length: n }, (_, i) => aug[i].slice(n, 2 * n));
}
